import React, { useContext } from 'react';
import CartItem from '../CartItem/CartItem';
import CartItemWidget from '../CartItemWidget/CartItemWidget';
import { navigateV2, dataSender, getRoute } from '../../../common/utils/router';
import UserContext, { StoreContext, UserProfileContext } from '../../../common/utils/getContext';
import { declOfNum, API_SERVER_URL } from '../../../common/utils/utils';
import T from '../../../common/components/T';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import CartItemGridAdmin from '../CartItemGridAdmin/CartItemGridAdmin';
import css from './Cart.module.scss';
import classnames from 'classnames';
import Display from '../../../common/components/Display';

const Cart = ({ products, type = 'general', subtype = 'main', price, price_marketing, funcs, formDataError }) => {
    const { userToken, lang, setAlertData, localization, marketingCurrency } = useContext(UserContext);
    const { cartData, setCartData, setShowRegWindow } = useContext(StoreContext) || {};
    const { profileData } = useContext(UserProfileContext);
    const router = useRouter();

    const deleteProducts = async () => {
        if (cartData.id) {
            dataSender(
                `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/clear?_method=DELETE`,
                'DELETE',
                false,
                (response) => {
                    setCartData(response.data?.data);
                    if (router.asPath === getRoute('/store/cart') && !response?.data?.data?.items?.length) {
                        navigateV2('/store');
                    }
                },
                () => {
                    setAlertData({
                        type: 'error',
                        cont: true,
                        default: 'error_delete_data'
                    });
                },
                userToken,
                lang,
                profileData?.currency?.code || localization?.currency
            );
        }
    };

    return type === 'general' ? (
        <div className={css.cartWrapper}>
            {products.map((item) => (
                <CartItem funcs={funcs} type={subtype} item={item} key={item.id} cartError={formDataError?.cart} />
            ))}
        </div>
    ) : type === 'widget' && products.length > 0 ? (
        <div className={css.cartWrapperWidget}>
            <div>
                <div className={css.cartTitleWidget}>
                    <T textName='store-inBasket' defaultStr='В корзине' page='/store' /> {products.length}{' '}
                    {declOfNum(products.length, [
                        <T key={'cartTitleWidget_1'} textName='store-inBasket-product' defaultStr='товар' page='/store' />,
                        <T key={'cartTitleWidget_2'} textName='store-inBasket-product2' defaultStr='товара' page='/store' />,
                        <T key={'cartTitleWidget_3'} textName='store-inBasket-product3' defaultStr='товаров' page='/store' />
                    ])}
                </div>
                <div className={css.flexRow}>
                    <div className={css.cartItemSubtitleWidget}>
                        <T textName='storeOnSums' defaultStr='На сумму' page='/store' />:
                    </div>
                    <div className={css.totalPrice}>{price}</div>
                    <div className={css.totalMarketingPriceWidget}>
                        {price_marketing || (
                            <Display
                                type='value'
                                data={{
                                    value: 0,
                                    currency: marketingCurrency
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className={css.cartItemWidget}>
                {products.map((elem, idx) => (
                    <CartItemWidget item={elem} key={`cartItem${idx}`} />
                ))}
            </div>
            <div
                className={css.buttonPrimarySmall}
                onClick={() => {
                    if (!userToken) {
                        setShowRegWindow(true);
                    } else {
                        navigateV2('/store/cart');
                    }
                }}
            >
                <T textName='storeOrderCreate' defaultStr='Оформить заказ' page='/store' />
            </div>
        </div>
    ) : type === 'hover-widget' && products.length > 0 ? (
        <div>
            <div className={css.cartHeaderWidgetHover}>
                <div className={css.cartTitleWidgetHover}>
                    <T textName='store-inBasket' defaultStr='В корзине' page='/store' /> {products.length}{' '}
                    {declOfNum(products.length, [
                        <T key={'cartTitleWidget2_1'} textName='store-inBasket-product' defaultStr='товар' page='/store' />,
                        <T key={'cartTitleWidget2_2'} textName='store-inBasket-product2' defaultStr='товара' page='/store' />,
                        <T key={'cartTitleWidget2_3'} textName='store-inBasket-product3' defaultStr='товаров' page='/store' />
                    ])}
                </div>
                <div className={css.cartDelete} onClick={() => deleteProducts()}>
                    <T textName='storeClear' defaultStr='Очистить' page='/store' />
                </div>
            </div>
            <div className={css.cartBodyWidgetHover}>
                {products.map((item, idx) => (
                    <CartItem item={item} key={`product${idx}`} />
                ))}
            </div>
            <div>
                <div className={css.cartFooterWidget}>
                    <div>
                        <div className={css.cartItemSubtitleWidgetHover}>
                            <T textName='storeTotalPrice' defaultStr='Всего на сумму' page='/store' />:
                        </div>
                        <div className={css.flexRow}>
                            <div className={css.totalPriceWidgetHover}>{price}</div>
                            <div className={css.totalMarketingPrice}>
                                {price_marketing || (
                                    <Display
                                        type='value'
                                        data={{
                                            value: 0,
                                            currency: marketingCurrency
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div
                        className={css.buttonPrimarySmall}
                        onClick={() => {
                            if (!userToken) {
                                setShowRegWindow(true);
                            } else {
                                navigateV2('/store/cart');
                            }
                        }}
                    >
                        <T textName='storeOrderCreate' defaultStr='Оформить заказ' page='/store' />
                    </div>
                </div>
            </div>
        </div>
    ) : type === 'header-general' ? (
        <div className={css.cartGrid}>
            <div className={classnames(css.cartWrapper, css.cartWrapperHeader)}>
                {products && products.length > 0 && (
                    <div className={classnames(css.cartWrapperHead, css.cartWrapperHeadBackground)}>
                        <div
                            style={{ textAlign: 'left' }}
                            className={classnames(css.cartWrapperHeadItem, css.cartWrapperHeadItem_First)}
                        >
                            <T textName='storeProduct' defaultStr='Товар' page='/store' />
                        </div>

                        <div
                            style={{ textAlign: 'center' }}
                            className={classnames(css.cartWrapperHeadItem, css.cartWrapperHeadItemML)}
                        >
                            <T textName='storePrice' defaultStr='Цена' page='/store' />
                        </div>
                        <div style={{ textAlign: 'center' }} className={css.cartWrapperHeadItem}>
                            <T textName='storeCount' defaultStr='Кол-во' page='/store' />
                        </div>
                        <div className={classnames(css.cartWrapperHeadItem, css.cartWrapperHeadItemPrices)}>
                            <T textName='storeTotal' defaultStr='Итого' page='/store' />
                        </div>
                        <div className={classnames(css.cartWrapperHeadItem, css.cartWrapperHeadItem_Last)}></div>
                    </div>
                )}
                {products.map((item, idx) => (
                    <CartItemGridAdmin item={item} key={`product${idx}`} price={true} article={true} funcs={funcs} type={type} />
                ))}
            </div>
        </div>
    ) : (
        <div></div>
    );
};
Cart.propTypes = {
    products: PropTypes.array,
    styles: PropTypes.object,
    type: PropTypes.oneOf(['general', 'header-general', 'hover-widget', 'widget']),
    price: PropTypes.node,
    price_marketing: PropTypes.node,
    funcs: PropTypes.object,
    page: PropTypes.string
};
export default Cart;
